import axios from "axios";

const PRODUCT_LIST_URL =
  process.env.REACT_APP_PRODUCT_LIST_URL ||
  "https://stg-wms-api.jnm.digital/api/v2/get-product-list";

  const bearer_token = process.env.REACT_APP_AUTH_TOKEN || "";

const isUsableImage = (value) => Boolean(value) && value !== "null";

export const mapProductForHeader = (product) => ({
  id: product.id,
  name: product.product_name || product.name || product.domain_url,
  avatar: isUsableImage(product.image_url_50_50)
    ? product.image_url_50_50
    : isUsableImage(product.image_url)
      ? product.image_url
      : isUsableImage(product.avatar)
        ? product.avatar
        : "",
  domain_url: product.domain_url,
  is_active: product.is_active,
});

export const fetchProductList = async () => {
  const response = await axios.get(PRODUCT_LIST_URL,{headers: {Authorization: `Bearer ${bearer_token}`}});
  const productList = response.data?.data?.productList || [];
  return productList
    .filter((product) => String(product.is_active) === "1")
    .map(mapProductForHeader);
};

export default { fetchProductList, mapProductForHeader };
